import { GraphQLTypes, InputType, Selector, $ } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';

const usersSelector = Selector('User')({
  email: true,
  id: true,
  updatedAt: true,
  uuid: true,
  firstName: true,
  lastName: true,
  role: {
    name: true,
    id: true,
  },
});

const leaderboardSelector = Selector('LeaderboardEntry')({
  username: true,
  avatar: {
    fileName: true,
    id: true,
  },
  position: true,
  score: true,
});

const updatedUserWithTokensSelector = Selector('UpdatedUserWithTokens')({
  tokens: {
    access_token: true,
    refresh_token: true,
  },
  updatedUser: {
    isChallengeable: true,
    username: true,
  },
});

const usersPaginationSelector = Selector('UserPagination')({
  users: usersSelector,
  total: true,
});

export const GQL_UPDATE_USER = typedGql('mutation')({
  updateUser: [
    { updateUserInput: $('updateUserInput', 'UpdateUserInput!') },
    updatedUserWithTokensSelector,
  ],
});

export const GQL_DELETE_USER = typedGql('mutation')({
  deleteUser: [
    {
      id: $('id', 'Int!'),
    },
    true,
  ],
});

export const GQL_USER = typedGql('query', { scalars })({
  getUser: [{ id: $('id', 'Int!') }, usersSelector],
});

export const GQL_LEADERBOARD = typedGql('query', { scalars })({
  getLeaderboard: {
    ...leaderboardSelector,
  },
});

export const GQL_USERS_WITH_FILTERS = typedGql('query', { scalars })({
  getFilteredUsers: [
    {
      findManyUserWithFiltersInput: $('input', 'FindManyUserWithFiltersInput!'),
    },
    usersPaginationSelector,
  ],
});

export const GQL_USERS = typedGql('query', { scalars })({
  getUsers: {
    ...usersSelector,
  },
});

export type StoredUsers = InputType<GraphQLTypes['User'], typeof usersSelector>;

export type StoredLeaderoard = InputType<
  GraphQLTypes['LeaderboardEntry'],
  typeof leaderboardSelector
>;
